import { render, staticRenderFns } from "./SignUpStore.vue?vue&type=template&id=71fd5550&scoped=true&"
import script from "./SignUpStore.vue?vue&type=script&lang=js&"
export * from "./SignUpStore.vue?vue&type=script&lang=js&"
import style0 from "./SignUpStore.vue?vue&type=style&index=0&id=71fd5550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd5550",
  null
  
)

export default component.exports